import { navigation } from "../data";
import { Link } from "react-scroll";
import Resume from "../components/fw18_0047-Ghanisht-khurana-Resume.pdf"

function Nav() {
const handleTheClick = ()=>{
  window.open(Resume)
}

  return (
    <nav>
      <ul className="flex space-x-8 capitalize text-[15px]">
        {navigation.map((item, index) => {
          return (
            <li
              className="text-white hover:text-violet-400 cursor-pointer"
              key={index}
            >
              <Link
                to={item.href}
                activeClass="active"
                spy={true}
                smooth={true}
                duration={500}
                offset={-70}
                className="transition-all duration-300"
              >
                {item.name}
              </Link>
            </li>
          );
        })}
        {/* <li>
          <a href="https://drive.google.com/uc?id=1D_caW2ifqTWnrfp_QuCsYHo9tdRnyLIA&export=download">
            <a
              className="text-white hover:text-violet-400 cursor-pointer"
              target="_blank"
              href="https://drive.google.com/file/d/1D_caW2ifqTWnrfp_QuCsYHo9tdRnyLIA/view"
            >
              Resume
            </a>
          </a>
        </li> */}
        <a onClick={handleTheClick} className="text-white hover:text-violet-400 cursor-pointer" href={Resume} target='_blank' download='fw18_0047-Ghanisht-khurana-Resume'>Resume</a>
      </ul>
    </nav>
  );
}

export default Nav;
